import epsClient from 'enrollment-platform/api/eps.client'
import type {
  AuditRun,
  AuditRunList,
  AuditRunStatus,
  OverlapEmployeeDetail,
  RunEmployeesResponse,
  TriggerRunResponse,
} from './enrollment-overlap.types'

// NOTE (PHI): responses carry employee identifiers and benefit details. Never
// log them, send them to analytics or persist them in browser storage.
const BASE_PATH = '/api/v1/audit/enrollment/enrollment-overlap-audit'

export interface PagingParams {
  page: number
  pageSize: number
}

export interface ListRunsParams extends PagingParams {
  status?: AuditRunStatus
}

export const triggerRun = async (): Promise<TriggerRunResponse> => {
  const { data } = await epsClient.post<TriggerRunResponse>(`${BASE_PATH}/runs`)
  return data
}

export const fetchRuns = async ({
  page,
  pageSize,
  status,
}: ListRunsParams): Promise<AuditRunList> => {
  const { data } = await epsClient.get<AuditRunList>(`${BASE_PATH}/runs`, {
    params: { page, pageSize, status },
  })
  return data
}

export const fetchRun = async (runId: string): Promise<AuditRun> => {
  const { data } = await epsClient.get<AuditRun>(
    `${BASE_PATH}/runs/${encodeURIComponent(runId)}`
  )
  return data
}

export const fetchRunEmployees = async (
  runId: string,
  { page, pageSize }: PagingParams
): Promise<RunEmployeesResponse> => {
  const { data } = await epsClient.get<RunEmployeesResponse>(
    `${BASE_PATH}/runs/${encodeURIComponent(runId)}/employees`,
    { params: { page, pageSize } }
  )
  return data
}

export const fetchEmployeeDetail = async (
  runId: string,
  employeePublicKey: string
): Promise<OverlapEmployeeDetail> => {
  const { data } = await epsClient.get<OverlapEmployeeDetail>(
    `${BASE_PATH}/runs/${encodeURIComponent(
      runId
    )}/employees/${encodeURIComponent(employeePublicKey)}`
  )
  return data
}
